/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

export const TooltipContainer = styled.div`
  width: max-content;
  height: max-content;
  background: #97f8fb;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 36px;
  color: #0b29fb;
  opacity: 0;
  transition: opacity 0.4s;
  visibility: hidden;
  z-index: 999;

  &::before {
    content: '';
    border-style: solid;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    left: -6px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #97f8fb;
    border-left: none;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;

  &:hover ${TooltipContainer} {
    opacity: 1;
    visibility: visible;
  }
`;

export const TootipTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #0b29fb;
  text-align: initial;
  display: block;
  margin-bottom: 5px;
  text-align: center;
  padding: 8px;
`;

export const TolltipItens = styled.div`
  text-align: initial;
`;
